export const feeAbi = ['function queryOracle() view returns (uint256)'];
